import { render, staticRenderFns } from "./JudgeListComponent.vue?vue&type=template&id=39abff63"
import script from "./JudgeListComponent.vue?vue&type=script&lang=js"
export * from "./JudgeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports